export const visit = (vm, at) => {
at({ "pt-br": { "pricingPage": { "detailedTermSelector": { "payMonthly": "Pagar mensalmente", "payAnnually": "Pagar anualmente", "commitMonthly": "Compromisso mensal", "commitAnnually": "Compromisso anual", "bestValue": "Melhor valor" } } } });
};